import api from './api';
import type { QuizAnswerSubmission, QuizSubmitResponse, QuizScoreEntry } from '@/types';

export const quizService = {
  async submitAll(
    courseId: string,
    experimentNumber: number,
    answers: QuizAnswerSubmission[]
  ): Promise<QuizSubmitResponse | null> {
    const res = await api.post<QuizSubmitResponse>(
      `/quiz/${courseId}/${experimentNumber}/submit-all`,
      { answers }
    );
    return res.success ? res.data! : null;
  },

  async getResponses(courseId: string, experimentNumber: number) {
    const res = await api.get<{ success: boolean; responses: QuizSubmitResponse['responses'] }>(
      `/quiz/${courseId}/${experimentNumber}/responses`
    );
    return res.success ? res.data!.responses : [];
  },

  async getCourseScores(courseId: string): Promise<QuizScoreEntry[]> {
    const res = await api.get<{ success: boolean; scores: QuizScoreEntry[] }>(
      `/quiz/${courseId}/scores`
    );
    return res.success ? res.data!.scores : [];
  },
};
